const messages: Record<string, Record<string, string>> = {
  sk: {
    'plugin.steps.branches': 'Prevádzka',
    'plugin.branchesStep.title': 'Vyberte prevádzku',
    'plugin.steps.branchesDesc': 'Vyberte prevádzku.',
    'plugin.steps.products': 'Služba',
    'plugin.steps.productsDesc': 'Vyberte službu alebo balík.',
    'plugin.steps.datetime': 'Dátum a čas',
    'plugin.steps.datetimeDesc': 'Zvoľte dátum a čas.',
    'plugin.dateStep.title': 'Vyberte dátum a čas',
    'plugin.dateStep.morning': 'Dopoludnia',
    'plugin.dateStep.afternoon': 'Popoludní',
    'plugin.dateStep.noSlotsForDay': 'Pre tento deň nie sú dostupné termíny.',
    'plugin.dateStep.fixedWorkshopDate': 'Workshop má pevný dátum',
    'plugin.steps.employees': 'Zamestnanec',
    'plugin.steps.employeesDesc': 'Vyberte zamestnanca.',
    'plugin.employeesStep.title': 'Vyberte zamestnanca',
    'plugin.employeesStep.anyEmployee': 'Nezáleží',
    'plugin.employeesStep.firstAvailable': 'Najbližší možný termín',
    'plugin.employeesStep.employee': 'Zamestnanec',
    'plugin.steps.customer': 'Osobné údaje',
    'plugin.steps.customerDesc': 'Zadajte osobné údaje.',
    'plugin.customerStep.nameLabel': 'Meno',
    'plugin.customerStep.nameHint': 'Zadajte meno',
    'plugin.customerStep.surnameLabel': 'Priezvisko',
    'plugin.customerStep.surnameHint': 'Zadajte priezvisko',
    'plugin.customerStep.emailLabel': 'Emailová adresa',
    'plugin.customerStep.emailHint': 'Zadajte emailovú adresu',
    'plugin.customerStep.phoneLabel': 'Telefónne číslo',
    'plugin.customerStep.phoneHint': 'Zadajte svoje telefónne číslo',
    'plugin.customerStep.numberOfPeopleLabel': 'Počet osôb',
    'plugin.customerStep.noteLabel': 'Poznámka (voliteľné)',
    'plugin.customerStep.noteHint': 'Zadajte voliteľnú poznámku',
    'plugin.customerStep.capacityAvailable': 'dostupných',
    'plugin.customerStep.emailError': 'Email môže obsahovať iba písmená, čísla a štandardné emailové symboly',
    'plugin.customerStep.phoneError': 'Telefónne číslo musí byť v formáte +421 alebo 421 a 9 číslic (napr. +421949385518)',
    'plugin.customerStep.couponCodeLabel': 'Kód kupónu',
    'plugin.customerStep.couponCodeHint': 'Zadajte kód kupónu',
    'plugin.customerStep.couponCodeRequired': 'Kód kupónu je povinný',
    'plugin.customerStep.couponPasswordLabel': 'Heslo kupónu',
    'plugin.customerStep.couponPasswordHint': 'Zadajte heslo kupónu',
    'plugin.customerStep.couponPasswordRequired': 'Heslo kupónu je povinné',
    'plugin.customerStep.couponVerificationFailed': 'Kupón nie je možné použiť pre túto rezerváciu',
    'plugin.paymentStep.instructions': 'Rezervácia bude dokončená po odoslaní. Platbu môžete dokončiť podľa inštrukcií po vytvorení rezervácie.',
    'plugin.steps.payment': 'Platba',
    'plugin.steps.paymentDesc': 'Dokončite platbu.',
    'plugin.steps.summary': 'Zhrnutie',
    'plugin.steps.summaryDesc': 'Skontrolujte rezerváciu.',
    'plugin.header.title': 'infinela - rezervačný systém',
    'plugin.actions.next': 'Pokračovať',
    'plugin.actions.back': 'Späť',
    'plugin.actions.submit': 'Vytvoriť rezerváciu',
    'plugin.loading': 'Načítavam...',
    'plugin.error.load': 'Nepodarilo sa načítať údaje.',
    'plugin.error.submit': 'Rezerváciu sa nepodarilo odoslať.',
    'plugin.error.submitGenericWithContact': 'Pri rezervácii sa niečo pokazilo. Skúste to prosím neskôr.',
    'plugin.error.couponFailed': 'Overenie kupónu zlyhalo. Skontrolujte kód a heslo kupónu.',
    'plugin.error.fullyBooked': 'Tento termín je už obsadený.',
    'plugin.notifications.reservationCreated': 'Rezervácia bola úspešne vytvorená.',
    'plugin.productsStep.packages': 'Balíčky',
    'plugin.productsStep.services': 'Služby',
    'plugin.productsStep.workshops': 'Udalosti',
    'plugin.productsStep.noProducts': 'Žiadne produkty',
    'plugin.productsStep.noProductsDescription': 'Pre túto prevádzku zatiaľ nie sú dostupné žiadne služby ani balíčky.',
    'plugin.productsStep.fullyBooked': 'Obsadené',
    'plugin.summary.title': 'Súhrn rezervácie',
    'plugin.summary.employee': 'Zamestnanec',
    'plugin.summary.dateTime': 'Dátum a čas',
    'plugin.summary.anyEmployee': 'Nezáleží',
    'plugin.summary.paymentMethod': 'Platobná metóda',
    'plugin.summary.paymentCard': 'Platba kartou',
    'plugin.summary.paymentCardOnline': 'Platba kartou online',
    'plugin.summary.label': 'Súhrn',
    'plugin.summary.agreeWith': 'Súhlasím s',
    'plugin.summary.termsLink': 'obchodnými podmienkami',
    'plugin.summary.agreeProcessingOf': 'Súhlasím so',
    'plugin.summary.privacyLink': 'spracovaním osobných údajov',
    'plugin.summary.errorAgreeTerms': 'Pre pokračovanie musíte súhlasiť s obchodnými podmienkami.',
    'plugin.summary.errorAgreePrivacy': 'Pre pokračovanie musíte súhlasiť so spracovaním osobných údajov.',
    'plugin.legal.loading': 'Načítavam...',
    'plugin.legal.termsTitle': 'Obchodné podmienky',
    'plugin.legal.privacyTitle': 'Súhlas so spracovaním osobných údajov',
    'plugin.summary.requiredPaymentNote': 'Platba je potrebná. Sumu uhradíte v prevádzke {facilityName}.',
    'plugin.summary.requiredPaymentCardNote': 'Táto prevádzka požaduje platbu kartou online. Po potvrdení budete presmerovaní na platobnú bránu.',
    'plugin.summary.paymentMethodRequired': 'Vyberte platobnú metódu.',
    'plugin.summary.selectedPayment': 'Vybrané:',
    'plugin.buttons.confirmReservation': 'Potvrdiť rezerváciu',
    'plugin.buttons.nextReservation': 'Ďalšia rezervácia',
    'plugin.buttons.createAnotherReservation': 'Chcem vytvoriť novú rezerváciu',
    'plugin.payment.return.checkingStatus': 'Kontrolujem stav platby...',
    'plugin.payment.return.statusUnavailable': 'Stav platby nie je k dispozícii.',
    'plugin.payment.return.successful': 'Platba bola úspešne dokončená.',
    'plugin.payment.return.failed': 'Platba zlyhala.',
    'plugin.payment.return.cancelled': 'Platba bola zrušená.',
    'plugin.payment.return.pending': 'Platba čaká na spracovanie.',
    'plugin.shell.paymentCallbackProcessing': 'Spracovávam platobnú odpoveď...',
    'plugin.readonly.title': 'Rezervácia (iba prehliadka)',
  },
  en: {
    'plugin.steps.branches': 'Branch',
    'plugin.branchesStep.title': 'Select branch',
    'plugin.steps.branchesDesc': 'Select branch.',
    'plugin.steps.products': 'Service',
    'plugin.steps.productsDesc': 'Select service or package.',
    'plugin.steps.datetime': 'Date & time',
    'plugin.steps.datetimeDesc': 'Choose date and time.',
    'plugin.dateStep.title': 'Select date and time',
    'plugin.dateStep.morning': 'Morning',
    'plugin.dateStep.afternoon': 'Afternoon',
    'plugin.dateStep.noSlotsForDay': 'No available slots for this day.',
    'plugin.dateStep.fixedWorkshopDate': 'Workshop has a fixed date',
    'plugin.steps.employees': 'Employee',
    'plugin.steps.employeesDesc': 'Select employee.',
    'plugin.employeesStep.title': 'Select employee',
    'plugin.employeesStep.anyEmployee': 'No preference',
    'plugin.employeesStep.firstAvailable': 'First available slot',
    'plugin.employeesStep.employee': 'Employee',
    'plugin.steps.customer': 'Customer details',
    'plugin.steps.customerDesc': 'Enter personal details.',
    'plugin.customerStep.nameLabel': 'Name',
    'plugin.customerStep.nameHint': 'Enter name',
    'plugin.customerStep.surnameLabel': 'Surname',
    'plugin.customerStep.surnameHint': 'Enter surname',
    'plugin.customerStep.emailLabel': 'Email address',
    'plugin.customerStep.emailHint': 'Enter email address',
    'plugin.customerStep.phoneLabel': 'Phone number',
    'plugin.customerStep.phoneHint': 'Enter your phone number',
    'plugin.customerStep.numberOfPeopleLabel': 'Number of people',
    'plugin.customerStep.noteLabel': 'Note (optional)',
    'plugin.customerStep.noteHint': 'Enter an optional note',
    'plugin.customerStep.capacityAvailable': 'available',
    'plugin.customerStep.emailError': 'Email must contain only letters, numbers, and standard email symbols',
    'plugin.customerStep.phoneError': 'Phone number must be in format +421 or 421 followed by 9 digits (e.g. +421949385518)',
    'plugin.customerStep.couponCodeLabel': 'Coupon code',
    'plugin.customerStep.couponCodeHint': 'Enter coupon code',
    'plugin.customerStep.couponCodeRequired': 'Coupon code is required',
    'plugin.customerStep.couponPasswordLabel': 'Coupon password',
    'plugin.customerStep.couponPasswordHint': 'Enter coupon password',
    'plugin.customerStep.couponPasswordRequired': 'Coupon password is required',
    'plugin.customerStep.couponVerificationFailed': 'This coupon cannot be used for this reservation',
    'plugin.paymentStep.instructions': 'Reservation will be completed after submission. You can complete the payment according to the instructions after creating the reservation.',
    'plugin.steps.payment': 'Payment',
    'plugin.steps.paymentDesc': 'Complete payment.',
    'plugin.steps.summary': 'Summary',
    'plugin.steps.summaryDesc': 'Review reservation.',
    'plugin.header.title': 'infinela - reservation system',
    'plugin.actions.next': 'Continue',
    'plugin.actions.back': 'Back',
    'plugin.actions.submit': 'Create reservation',
    'plugin.summary.title': 'Reservation summary',
    'plugin.summary.employee': 'Employee',
    'plugin.summary.dateTime': 'Date & time',
    'plugin.summary.anyEmployee': 'No preference',
    'plugin.summary.paymentMethod': 'Payment method',
    'plugin.summary.paymentCard': 'Card payment',
    'plugin.summary.paymentCardOnline': 'Online card payment',
    'plugin.summary.label': 'Summary',
    'plugin.summary.agreeWith': 'I agree to the',
    'plugin.summary.termsLink': 'terms and conditions',
    'plugin.summary.agreeProcessingOf': 'I agree to the',
    'plugin.summary.privacyLink': 'processing of personal data',
    'plugin.summary.errorAgreeTerms': 'You must agree to the terms and conditions to continue.',
    'plugin.summary.errorAgreePrivacy': 'You must agree to the processing of personal data to continue.',
    'plugin.legal.loading': 'Loading...',
    'plugin.legal.termsTitle': 'Terms and Conditions',
    'plugin.legal.privacyTitle': 'Personal Data Processing Consent',
    'plugin.summary.requiredPaymentNote': 'Payment is required. You will pay at {facilityName}.',
    'plugin.summary.requiredPaymentCardNote': 'Online card payment is required. After confirming you will be redirected to the payment gateway.',
    'plugin.summary.paymentMethodRequired': 'Please select a payment method.',
    'plugin.summary.selectedPayment': 'Selected:',
    'plugin.buttons.confirmReservation': 'Confirm reservation',
    'plugin.buttons.nextReservation': 'Next reservation',
    'plugin.buttons.createAnotherReservation': 'I want to create a new reservation',
    'plugin.payment.return.checkingStatus': 'Checking payment status...',
    'plugin.payment.return.statusUnavailable': 'Payment status unavailable.',
    'plugin.payment.return.successful': 'Payment completed successfully.',
    'plugin.payment.return.failed': 'Payment failed.',
    'plugin.payment.return.cancelled': 'Payment cancelled.',
    'plugin.payment.return.pending': 'Payment pending.',
    'plugin.shell.paymentCallbackProcessing': 'Processing payment callback...',
    'plugin.loading': 'Loading...',
    'plugin.error.load': 'Failed to load data.',
    'plugin.error.submit': 'Failed to submit reservation.',
    'plugin.error.submitGenericWithContact': 'Something went wrong with the reservation. Please try again later.',
    'plugin.error.couponFailed': 'Coupon verification failed. Please check the coupon code and password.',
    'plugin.error.fullyBooked': 'This time slot is fully booked.',
    'plugin.notifications.reservationCreated': 'Reservation was successfully created.',
    'plugin.productsStep.packages': 'Packages',
    'plugin.productsStep.services': 'Services',
    'plugin.productsStep.workshops': 'Events',
    'plugin.productsStep.noProducts': 'No products',
    'plugin.productsStep.noProductsDescription': 'No services or packages are currently available for this branch.',
    'plugin.productsStep.fullyBooked': 'Fully booked',
    'plugin.readonly.title': 'Reservation (read-only)',
  },
  cs: {
    'plugin.steps.branches': 'Pobočka',
    'plugin.branchesStep.title': 'Vyberte provozovnu',
    'plugin.steps.branchesDesc': 'Vyberte provozovnu.',
    'plugin.steps.products': 'Služba',
    'plugin.steps.productsDesc': 'Vyberte službu nebo balíček.',
    'plugin.steps.datetime': 'Datum a čas',
    'plugin.steps.datetimeDesc': 'Zvolte datum a čas.',
    'plugin.dateStep.title': 'Vyberte datum a čas',
    'plugin.dateStep.morning': 'Dopoledne',
    'plugin.dateStep.afternoon': 'Odpoledne',
    'plugin.dateStep.noSlotsForDay': 'Pro tento den nejsou dostupné termíny.',
    'plugin.dateStep.fixedWorkshopDate': 'Workshop má pevný datum',
    'plugin.steps.employees': 'Zaměstnanec',
    'plugin.steps.employeesDesc': 'Vyberte zaměstnance.',
    'plugin.employeesStep.title': 'Vyberte zaměstnance',
    'plugin.employeesStep.anyEmployee': 'Nezáleží',
    'plugin.employeesStep.firstAvailable': 'Nejbližší možný termín',
    'plugin.employeesStep.employee': 'Zaměstnanec',
    'plugin.steps.customer': 'Údaje zákazníka',
    'plugin.steps.customerDesc': 'Zadejte osobní údaje.',
    'plugin.customerStep.nameLabel': 'Jméno',
    'plugin.customerStep.nameHint': 'Zadejte jméno',
    'plugin.customerStep.surnameLabel': 'Příjmení',
    'plugin.customerStep.surnameHint': 'Zadejte příjmení',
    'plugin.customerStep.emailLabel': 'E-mailová adresa',
    'plugin.customerStep.emailHint': 'Zadejte e-mailovou adresu',
    'plugin.customerStep.phoneLabel': 'Telefonní číslo',
    'plugin.customerStep.phoneHint': 'Zadejte své telefonní číslo',
    'plugin.customerStep.numberOfPeopleLabel': 'Počet osob',
    'plugin.customerStep.noteLabel': 'Poznámka (volitelné)',
    'plugin.customerStep.noteHint': 'Zadejte volitelnou poznámku',
    'plugin.customerStep.capacityAvailable': 'dostupných',
    'plugin.customerStep.emailError': 'Email může obsahovat pouze písmena, čísla a standardní emailové symboly',
    'plugin.customerStep.phoneError': 'Telefonní číslo musí být ve formátu +421 nebo 421 a 9 číslic (např. +421949385518)',
    'plugin.paymentStep.instructions': 'Rezervace bude dokončena po odeslání. Platbu můžete dokončit podle instrukcí po vytvoření rezervace.',
    'plugin.steps.payment': 'Platba',
    'plugin.steps.paymentDesc': 'Dokončete platbu.',
    'plugin.steps.summary': 'Shrnutí',
    'plugin.steps.summaryDesc': 'Zkontrolujte rezervaci.',
    'plugin.header.title': 'infinela - rezervační systém',
    'plugin.actions.next': 'Pokračovat',
    'plugin.actions.back': 'Zpět',
    'plugin.actions.submit': 'Vytvořit rezervaci',
    'plugin.summary.title': 'Shrnutí rezervace',
    'plugin.summary.employee': 'Zaměstnanec',
    'plugin.summary.dateTime': 'Datum a čas',
    'plugin.summary.anyEmployee': 'Nezáleží',
    'plugin.summary.paymentMethod': 'Platební metoda',
    'plugin.summary.paymentCard': 'Platba kartou',
    'plugin.summary.paymentCardOnline': 'Platba kartou online',
    'plugin.summary.label': 'Shrnutí',
    'plugin.summary.agreeWith': 'Souhlasím s',
    'plugin.summary.termsLink': 'obchodními podmínkami',
    'plugin.summary.agreeProcessingOf': 'Souhlasím se',
    'plugin.summary.privacyLink': 'zpracováním osobních údajů',
    'plugin.summary.errorAgreeTerms': 'Pro pokračování musíte souhlasit s obchodními podmínkami.',
    'plugin.summary.errorAgreePrivacy': 'Pro pokračování musíte souhlasit se zpracováním osobních údajů.',
    'plugin.legal.loading': 'Načítám...',
    'plugin.legal.termsTitle': 'Obchodní podmínky',
    'plugin.legal.privacyTitle': 'Souhlas se zpracováním osobních údajů',
    'plugin.summary.requiredPaymentNote': 'Platba je vyžadována. Zaplatíte v provozovně {facilityName}.',
    'plugin.summary.requiredPaymentCardNote': 'Platba kartou online je povinná. Po potvrdení budete přesměrováni na platební bránu.',
    'plugin.summary.paymentMethodRequired': 'Vyberte platební metodu.',
    'plugin.summary.selectedPayment': 'Vybrané:',
    'plugin.buttons.confirmReservation': 'Potvrdit rezervaci',
    'plugin.buttons.nextReservation': 'Další rezervace',
    'plugin.buttons.createAnotherReservation': 'Chci vytvořit novou rezervaci',
    'plugin.payment.return.checkingStatus': 'Kontroluji stav platby...',
    'plugin.payment.return.statusUnavailable': 'Stav platby není k dispozici.',
    'plugin.payment.return.successful': 'Platba byla úspěšně dokončena.',
    'plugin.payment.return.failed': 'Platba selhala.',
    'plugin.payment.return.cancelled': 'Platba byla zrušena.',
    'plugin.payment.return.pending': 'Platba čeká na zpracování.',
    'plugin.shell.paymentCallbackProcessing': 'Zpracovávám platební odpověď...',
    'plugin.loading': 'Načítám...',
    'plugin.error.load': 'Nepodařilo se načíst údaje.',
    'plugin.error.submit': 'Rezervaci se nepodařilo odeslat.',
    'plugin.error.submitGenericWithContact': 'Při rezervaci se něco pokazilo. Zkuste to prosím později.',
    'plugin.error.couponFailed': 'Ověření kupónu selhalo. Zkontrolujte kód a heslo kupónu.',
    'plugin.error.fullyBooked': 'Tento termín je již obsazen.',
    'plugin.notifications.reservationCreated': 'Rezervace byla úspěšně vytvořena.',
    'plugin.productsStep.packages': 'Balíčky',
    'plugin.productsStep.services': 'Služby',
    'plugin.productsStep.workshops': 'Udalosti',
    'plugin.productsStep.noProducts': 'Žádné produkty',
    'plugin.productsStep.noProductsDescription': 'Pro tuto provozovnu zatím nejsou dostupné žádné služby ani balíčky.',
    'plugin.productsStep.fullyBooked': 'Obsazeno',
    'plugin.readonly.title': 'Rezervace (pouze prohlídka)',
  },
}

export function getLang(): string {
  if (typeof window === 'undefined') return 'sk'
  const params = new URLSearchParams(window.location.search)
  const lang = params.get('lang') ?? navigator.language?.slice(0, 2) ?? 'sk'
  return ['sk', 'en', 'cs'].includes(lang) ? lang : 'sk'
}

const dateLocaleMap: Record<string, string> = {
  sk: 'sk-SK',
  en: 'en',
  cs: 'cs-CZ',
}

export function getDateLocale(): string {
  return dateLocaleMap[getLang()] ?? 'sk-SK'
}

export function t(key: string): string {
  const lang = getLang()
  const map = messages[lang] ?? messages.sk
  return map[key] ?? key
}
